import { render, staticRenderFns } from "./IdentidyVerificationContainer.vue?vue&type=template&id=7f1298b0&scoped=true"
import script from "./IdentidyVerificationContainer.vue?vue&type=script&lang=js"
export * from "./IdentidyVerificationContainer.vue?vue&type=script&lang=js"
import style0 from "./IdentidyVerificationContainer.vue?vue&type=style&index=0&id=7f1298b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1298b0",
  null
  
)

export default component.exports